import * as ng from 'angular';
import { NgDblClick } from './ng-dbl-click.directive';


export const NgDblClickModule: string =
    ng.module('ng-dbl-click', [
    ])
        .directive('ngDblClick', NgDblClick)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/ng-dbl-click/ng-dbl-click.module.ts